import React from 'react';
import get from 'lodash/get';
import { bool, object } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { mobileFontSize } from './CommonStyles';
import { commonAutomationIds, bannerAutomationIds } from '../CoreMediaPage/CMPage.config';

const HeroSubHeadLine = (props) => {
    const primarySubHeadLine = get(props, 'teaserSubtitle', '');
    const styles = get(props, 'styles', {});
    const isPrimary = get(props, 'isPrimary', true);

    const componentStylingResp = {
        subTitleFontSize: {
            'body-1': `${dt(['text-normal', 'md:leading-normal'])}`,
            'body-2': `${dt(['text-xlarge', 'md:leading-8'])}`,
        },
    };
    let hero3ComponentSubHeadlineFontSize = '';

    if (props.deviceType.isMobile) {
        hero3ComponentSubHeadlineFontSize = dt([
            ...mobileFontSize(isPrimary ? 'primarySubHeadline' : 'secondarySubHeadline'),
        ]);
    } else {
        hero3ComponentSubHeadlineFontSize =
            componentStylingResp?.subTitleFontSize[styles?.subHeadlineFontSize];
    }

    const smBottomPadding = props.isLegalTextEmpty ? 'smOnly:mb-4' : 'smOnly:mb-1';

    return (
        <div
            className={`${hero3ComponentSubHeadlineFontSize} ${dt([
                'md:mb-2',
                smBottomPadding,
                'text-black',
                'smOnly:text-center',
            ])}`}
            id="heroSubHeadline"
            style={{ color: `#${styles?.subHeadlineColor}` }}
            data-automation-id={
                isPrimary ? commonAutomationIds?.MAINSUBTITLE : bannerAutomationIds?.SUBTITLE
            }
        >
            {primarySubHeadLine}
        </div>
    );
};

HeroSubHeadLine.defaultProps = {
    deviceType: {},
    isLegalTextEmpty: false,
};

HeroSubHeadLine.propTypes = {
    deviceType: object,
    isLegalTextEmpty: bool,
};

export default HeroSubHeadLine;
